import React from 'react';
import "../../styles/all.css"
import "../../styles/theme.css"
import "./footer.css"

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-gray-300 py-4 border-t border-gray-700">
      <div className="container mx-auto px-6 text-center">
        <p className="text-sm">
          © {currentYear} Your Admin Dashboard. All rights reserved.
        </p>
        { <div className="mt-2 text-xs flex justify-center gap-6">
          <a href="#" className="hover:text-white transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Terms & Conditions
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Technical Support
          </a>
        </div> }
      </div>
    </footer>
  );
};

export default Footer;